module.exports = __webpack_public_path__ + "static/media/earth.c9dd44b8.png";